import { useEffect } from 'react';
import SentryService from 'services/sentryService';

declare global {
  interface Window {
    testSentry?: () => void;
    sentryStatus?: () => Record<string, unknown>;
  }
}

const SentryInitializer = () => {
  const sentryService = SentryService.getInstance();

  useEffect(() => {
    const timer = setTimeout(() => {
      const status = sentryService.getStatus();
      console.log('🔍 Sentry Initialization Status:', status);

      if (sentryService.isActive) {
        console.log('✅ Sentry is active and capturing errors for environment:', status.environment);

        window.testSentry = () => {
          console.log('🧪 Sending test event to Sentry...');
          sentryService.captureError(new Error('Sentry manual test event'), { source: 'console' });
        };

        window.sentryStatus = () => {
          const currentStatus = sentryService.getStatus();
          console.log('📊 Sentry Status:', currentStatus);
          return currentStatus;
        };

        console.log('🧪 Debug commands available in console:');
        console.log('  - window.testSentry()   - Send a test event to Sentry');
        console.log('  - window.sentryStatus() - Get current Sentry status');
      } else {
        console.log(
          '❌ Sentry is disabled - no error tracking',
          '\nTo enable Sentry:',
          '\n1. Set VITE_SENTRY_DSN environment variable',
          '\n2. Or configure window.config.sentryDsn'
        );
      }
    }, 100);

    return () => {
      clearTimeout(timer);
      delete window.testSentry;
      delete window.sentryStatus;
    };
  }, [sentryService]);

  return null;
};

export default SentryInitializer;
